import { Checkbox, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { ProfileType } from "../../options-table/types/ProfileType";
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";

export function ProfileTypeSelector() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();
    
    async function handleSelection(eventArg: SelectChangeEvent<string[]>) {
        if (selectedPortfolio === undefined ||
            selectedPortfolio === null ||
            selectedPortfolio.portfolioSettings === null
        ) {
            return;
        }
        
        const selection = eventArg.target.value;

        selectedPortfolio.portfolioSettings.selectedProfileTypes = Array.isArray(selection)
            ? selection.map(x => ProfileType[x as keyof typeof ProfileType])
            : [ProfileType[selection as keyof typeof ProfileType]];
        
        updateSelectedPortfolio();
        saveSelectedPortfolio();
    }
    
    const selectedProfileTypes = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.selectedProfileTypes
        : [];
    
    return (
        <FormControl
            variant="standard"
            sx={{ width: 240}}
            size="small"
        >
            <InputLabel id="option-parameter-types-label">
                <b>Profile types to show</b>
            </InputLabel>
            <Select
                labelId="option-parameter-types-label"
                value={selectedProfileTypes.map(x => ProfileType[x])}
                onChange={handleSelection}
                multiple
                renderValue={(selected) => selected.join(', ')}
            >
               {Object.keys(ProfileType)
                   .filter((key) => isNaN(Number(key)))
                   .map((typeName) => (
                        <MenuItem
                            key={typeName}
                            value={typeName}
                        >
                            <Checkbox
                                checked={selectedProfileTypes.indexOf(ProfileType[typeName as keyof typeof ProfileType]) > -1}
                                sx={{ p: 0.25 }}
                            />
                            {typeName}
                        </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}